import script from "./GenericTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericTitle.vue?vue&type=script&setup=true&lang=js"

import "./GenericTitle.vue?vue&type=style&index=0&id=26faede2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26faede2"]])

export default __exports__